<template>
  <MarketingCampaignModal
    v-model:opened="marketingCampaignModalOpened"
    :campaign="campaign"
    @close="marketingCampaignModalCancel"
    @action="marketingCampaignModalAction"
  />
</template>
<script>
import { JavascriptHelpers } from "@core/helpers";
import { Logger } from "@core/helpers/logger.helpers";
import { MarketingService } from "@core/services";
import { ETAB_ROUTES } from "@etab/config";

import MarketingCampaignModal from "@etab/components/marketing-campaign/MarketingCampaign.modal.vue";
import { MarketingCampaignModel } from "@core/models";
import { MARKETING_CAMPAIGN_TYPES, MARKETING_CAMPAIGN_ACTIONS } from "@core/constants";

export default {
  components: {
    MarketingCampaignModal,
  },
  data() {
    return {
      campaign: new MarketingCampaignModel(),
      marketingCampaignModalOpened: false,
    };
  },
  created() {
    this.checkMarketingCampaign();
  },
  methods: {
    async checkMarketingCampaign() {
      try {
        // check if we need to show a modal to the user
        this.campaign = new MarketingCampaignModel(await MarketingService.getCampaignContent({ origin: "et" }));
        if (this.campaign.getCampaignId()) {
          this.openMarketingCampaignModal();
        }
      } catch (error) {
        // fail silently because it's not that important
        Logger.info("Marketing check failed, proceed with smart routing");
      }
    },
    openMarketingCampaignModal() {
      this.marketingCampaignModalOpened = true;
    },
    async closeMarketingCampaignModal() {
      this.marketingCampaignModalOpened = false;
    },
    marketingCampaignModalCancel({ campaign }) {
      this.closeMarketingCampaignModal({ campaign });
    },
    marketingCampaignModalAction({ campaign }) {
      // we close no matter what
      this.closeMarketingCampaignModal();
      const param = campaign.getParam();
      const type = campaign.getType();
      if (type === MARKETING_CAMPAIGN_TYPES.LINK) {
        JavascriptHelpers.openUrl(param, "_blank");
      } else if (type === MARKETING_CAMPAIGN_TYPES.ACTION) {
        switch (param) {
          case MARKETING_CAMPAIGN_ACTIONS.PROFILE:
            this.$router.push({ name: ETAB_ROUTES.account.profile.root.name }).catch(suppressedError => {});
            break;
          case MARKETING_CAMPAIGN_ACTIONS.ACCOUNT:
            this.$router.push({ name: ETAB_ROUTES.userMenu.main.name }).catch(suppressedError => {});
            break;
          default:
            // nothing happens
            break;
        }
      }
    },
  },
};
</script>
